import { render, staticRenderFns } from "./SelectPageDialog.vue?vue&type=template&id=883d1820&"
import script from "./SelectPageDialog.vue?vue&type=script&lang=js&"
export * from "./SelectPageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports